import { CONFIGURED_FEATURES, featureEnabled } from './feature-flags';
export const isIntermodalOrder = (order) => order.mode === 'intermodal';
export const isDrayageOrder = (order) => order.mode === 'drayage';
export const isOrderHazmat = (order) => {
    var _a;
    if (featureEnabled(CONFIGURED_FEATURES.ENABLE_MULTIPLE_HAZMAT_DETAILS) &&
        ((_a = order.hazmat_details) === null || _a === void 0 ? void 0 : _a.length)) {
        return order.hazmat_details.some((h) => {
            return ((h.hazmat_class && h.hazmat_class !== 'N/A') ||
                (h.hazmat_packaging_group && h.hazmat_packaging_group !== 'N/A') ||
                h.hazmat_description);
        });
    }
    else {
        const { hazmat_class, hazmat_description, hazmat_packaging_group } = order;
        if ((hazmat_class && hazmat_class !== 'N/A') ||
            (hazmat_packaging_group && hazmat_packaging_group !== 'N/A') ||
            hazmat_description) {
            return true;
        }
        return false;
    }
};
